<template>
    <section class="section">
        <div>
            <h2 class="font-weight-semibold font-22 mb-2">
                {{titles.resetPassword}} <span>Stark</span>.
            </h2>
            <p class="text-muted">
                {{titles.recoveryCodeAndResetPassword}}
            </p>

            <transition mode="out-in" name="in-out-translate-fade">
                <component
                        :code="code"
                        @next="next($event)"
                        v-bind:is="view"
                ></component>
            </transition>
            <!--end form-group-->
        </div>
    </section>
</template>

<script>
    import CodeForm from './codeForm';
    import PasswordForm from './passwordForm';
    import {titles} from '../../../utils/general/titles.js';

    export default {
        name: 'index',
        data() {
            return {
                titles,
                view: 'step1',
                code: ''
            };
        },
        components: {
            step1: CodeForm,
            step2: PasswordForm
        },
        methods: {
            next(code) {
                this.code = code;
                this.view = 'step2';
            }
        }
    };
</script>

<style scoped>
    .component-slide-enter-active,
    .component-slide-leave-active {
        transform: translateX(31px);
    }

    .component-slide-enter, .component-slide-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .in-out-translate-demo-wrapper {
        position: relative;
        height: 18px;
    }

    .in-out-translate-demo-wrapper button {
        position: absolute;
    }

    .in-out-translate-fade-enter-active,
    .in-out-translate-fade-leave-active {
        transition: all 0.5s;
    }

    .in-out-translate-fade-enter,
    .in-out-translate-fade-leave-active {
        opacity: 0;
    }

    .in-out-translate-fade-enter {
        transform: translateX(100px);
    }

    .in-out-translate-fade-leave-active {
        transform: translateX(-100px);
    }
</style>
